import dynamic from 'next/dynamic';

import type { DrupalBlock } from '@commons/types/drupal';

import type { Block } from '..';

/**
 * Lazy loading to reduce the initial bundle size.
 *
 * This does not work when used in a pagebuilder factory directly, because every items are loaded at once.
 * Doing it in the component itself ensures that the chunks are only loaded when the component is rendered.
 *
 * @see https://nextjs.org/docs/app/building-your-application/optimizing/lazy-loading
 */

const AnimatedHeadline = dynamic(() => import('./AnimatedHeadline'));

// Type definition for the AnimatedHeadlineBlock component properties.

export type AnimatedHeadlineProps = DrupalBlock<{
  startWords: string[];
  endWords: string[];
  delay: number;
}>;

/**
 * ImageRevealBlock component.
 */

const AnimatedHeadlineBlock: Block<AnimatedHeadlineProps> = (props) => (
  <AnimatedHeadline {...props} />
);

/**
 * This block uses GSAP ScrollTrigger, so we disable the default animation.
 */

AnimatedHeadlineBlock.supportsAnimation = false;

export default AnimatedHeadlineBlock;
